import styled from 'styled-components'

import { _XS_Normal, mainColors } from '@avantstay/backoffice-core'

export const AiCaption = styled.span`
  ${_XS_Normal};
  color: ${mainColors.accentDark};
  margin-top: 4px;
`
